export const INDIVIDUAL_ADDITIONAL_DATA_EXPORT_HEADS = [
  { id: "id", label: "ID" },
  { id: "individualId", label: "ID do Indivíduo" },
  { id: "weightKg", label: "Peso (kg)" },
  { id: "ageYear", label: "Idade (anos)" },
  { id: "recaptureLatitude", label: "Latitude de Recaptura" },
  { id: "recaptureLongitude", label: "Longitude de Recaptura" },
  { id: "observations", label: "Observações" },
  { id: "registeredBy", label: "Registrado Por" },
  { id: "createdAt", label: "Data de Criação" },
  { id: "updatedAt", label: "Data de Atualização" },
];
